import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-api-error-dialog',
  templateUrl: './api-error-dialog.component.html',
  styleUrls: ['./api-error-dialog.component.scss']
})
export class ApiErrorDialogComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    console.log("data==>",data);
    
  }
  
}
